module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/third-party.507bfe40.svg";